<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
let _this;
import axios from "axios"; // AJAX封装类
import { config } from "./utils/config"; //配置
export default {
  name: "App",
  data() {
    return {};
  },
  created() {
    _this = this;

    axios.defaults.headers["port"] = "admin";

    _this
      .$post("/system/systemTimestamp", "", "", "normal")
      .then((res) => {
        let time_difference =
          res.data.timestamp - Math.round(new Date() / 1000);

        sessionStorage.setItem("time_difference", time_difference);
      })
      .catch((err) => {});

    axios.defaults.headers["port"] = "administrator";
    axios.defaults.headers["city-tag"] = config.city_tag;











  },
};
</script>

<style lang="">
@import "./assets/css/main.css";
@import "./assets/css/color-dark.css";
</style>



// WEBPACK FOOTER //
// src/App.vue